import { render, staticRenderFns } from "./AiCommonBanner.vue?vue&type=template&id=6d79519d"
import script from "./AiCommonBanner.vue?vue&type=script&lang=js"
export * from "./AiCommonBanner.vue?vue&type=script&lang=js"
import style0 from "./AiCommonBanner.vue?vue&type=style&index=0&id=6d79519d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports